import { all, takeLatest, put } from "redux-saga/effects";
import * as types from "../../constants/actionTypes";
import { messagesRedirect } from "../../components/messageBox"
import { setLoader } from "./actions";


const getStateDashboard = state => state.Dashboard;

export function* logoutUser(params) {
    try {
        yield put(setLoader(true));

        localStorage.removeItem('UserData');
        yield put({ type: types.GLOBAL_HIDE_PROFILE})
        messagesRedirect("Logout Berhasil", "Anda akan di redirect ke halaman login.", "success", false, params.history, `/`);

        yield put(setLoader(false));
    } catch (error) {
        yield put(setLoader(false));
    }
}

export default function* rootSaga() {
    yield all([
        takeLatest(types.MODULE_AUTH_LOGOUT, logoutUser),
    ]);
}

